import { combineReducers } from 'redux'

import {
  marketoReducer as marketo,
  webexReducer as webex,
  listReducer as list
} from 'features/integrations'
import passthrough from 'reducers/core/passthrough'

import apiWebhooks from './api_webhooks'
import disconnectPopup from './disconnect_popup'
import facebookPixel from './facebook_pixel'
import gmail from './gmail'
import googleAnalytics from './google_analytics'
import googleMeet from './google_meet'
import gotomeeting from './gotomeeting'
import mailchimp from './mailchimp'
import microsoftTeams from './microsoft_teams'
import outlook from './outlook'
import paypal from './paypal'
import salesforce from './salesforce'
import stripe from './stripe'

export default combineReducers({
  api_webhooks: apiWebhooks,
  chrome: passthrough,
  desktop: passthrough,
  disconnect_popup: disconnectPopup,
  facebook_pixel: facebookPixel,
  gmail,
  gong: passthrough,
  google_analytics: googleAnalytics,
  google_meet: googleMeet,
  gotomeeting,
  intercom: passthrough,
  list,
  mailchimp,
  marketo,
  microsoft_teams: microsoftTeams,
  outlook,
  paypal,
  salesforce,
  stripe,
  webex,
  zapier: passthrough,
})
